module.exports = __webpack_public_path__ + "img/Alec_Bayot.ebf33c7c.png";